<template>
  <v-btn
    class="card-shadow rounded-2"
    :color="color"
    :dark="dark && !disabled"
    :fab="!noFab"
    :x-small="!large"
    :disabled="disabled"
    @click="$emit('onClick')"
  >
    <v-icon>{{ icon }}</v-icon> <slot />
  </v-btn>
</template>

<script>
  export default {
    name: 'IconBtn',

    props: {
      icon: {
        type: String,
        default: '',
      },

      color: {
        type: String,
        default: 'white',
      },

      dark: Boolean,
      noFab: Boolean,
      large: Boolean,
      disabled: Boolean,
    },
  };
</script>
